import React from "react";
import { TouchableOpacity, StyleSheet } from "react-native";
import Svg, {
  Path,
  Defs,
  Rect,
  G,
  ClipPath,
} from "react-native-svg";
import AppTheme from "../../AppTheme";

export default function ArrowDropdown({ isOpen, style, onPress = () => {} }) {
  const fillColor = AppTheme.DEFAULT_COLOR;

  return (
    <TouchableOpacity
      style={[style, isOpen && arrowStyles.up]}
      onPress={onPress}
    >
      <Svg
        width="10"
        height="10"
        viewBox="0 0 10 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <G clipPath="url(#clip0_down)">
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5 6.37081L8.96825 2.54429C9.23032 2.29157 9.62489 2.32571 9.84952 2.62055C10.0742 2.91539 10.0438 3.35927 9.78173 3.61199L5.40674 7.83073C5.17269 8.05642 4.82731 8.05642 4.59326 7.83073L0.218266 3.61199C-0.0438118 3.35927 -0.0741627 2.91539 0.150476 2.62055C0.375114 2.32571 0.769676 2.29157 1.03175 2.54429L5 6.37081Z"
            fill="#2D3142"
          />
        </G>
        <Defs>
          <ClipPath id="clip0_down">
            <Rect width="10" height="10" fill="white" />
          </ClipPath>
        </Defs>
      </Svg>
    </TouchableOpacity>
  );
}

const arrowStyles = StyleSheet.create({
  up: {
    transform: [{ rotate: "180deg" }],
  },
});
